import axios from 'axios';
import { MONTH_NAME } from '../constants/filters';

export const checkMobile = () => window.innerWidth <= 500;

export function createQueryParams<P>(params: P) {
  return Object.keys(params)
    .map((param) => {
      const value: any = params[param as keyof P];
      if ((value && value !== 'all') || value.toString() === 'false') {
        return `${param}=${value}`;
      } else {
        return null;
      }
    })
    .filter((item) => !!item)
    .join('&');
}

export function formatSecondsAsTime(secs: number) {
  if (!secs) {
    return '00:00';
  }

  let hr = Math.floor(secs / 3600);
  let min = Math.floor((secs - hr * 3600) / 60);
  let sec = Math.floor(secs - hr * 3600 - min * 60);

  if (min < 10) {
    // @ts-ignore
    min = '0' + min;
  }
  if (sec < 10) {
    // @ts-ignore
    sec = '0' + sec;
  }

  return min + ':' + sec;
}

export const secondsToTime = (e: number) => {
  // const h = Math.floor(e / 3600)
  //   .toString()
  //   .padStart(2, '0');
  const m = Math.floor((e % 3600) / 60)
    .toString()
    .padStart(2, '0');
  const s = Math.floor(e % 60)
    .toString()
    .padStart(2, '0');

  return m + ':' + s;
};

export const getFilterTitle = (title?: string) => {
  if (!title) {
    return '';
  }

  switch (title) {
    case 'Category':
      return 'Категории';
    case 'Scripture':
      return 'Писания';
    case 'Country':
      return 'Страна';
    case 'Locality':
      return 'Локация';
    case 'Book':
      return 'Книга';
    case 'Chapter':
      return 'Глава';
    default:
      return title;
  }
};

export const getFilterItemName = (title?: string | number, name?: string) => {
  if (!title || !name) {
    return '';
  }

  if (name === 'date__month') {
    // @ts-ignore
    return MONTH_NAME[title];
  }

  return title;
};

export const downloadFile = (uri: string, name: string) => {
  const link = document.createElement('a');
  // If you don't know the name or want to use
  // the webserver default set name = ''
  link.setAttribute('download', name);
  link.href = uri;
  document.body.appendChild(link);
  link.click();
  link.remove();
};

const downloadBlob = (blob: string, filename: string) => {
  const a = document.createElement('a');
  a.download = filename;
  a.href = blob;
  document.body.appendChild(a);
  a.click();
  a.remove();
};

export const downloadResource = (url: string, filename?: string) => {
  const name = filename || 'Архив_Прабхупады.mp3';
  fetch(url, {
    headers: {
      Accept: '*/*',
      'Access-Control-Allow-Origin': '*',
      'Content-type': 'audio/mpeg',
    },
  })
    .then((response) => {
      console.log('debug-response :', response);
      return response.blob();
    })
    .then((blob) => {
      console.log('debug-blob', blob, name);
      let blobUrl = window.URL.createObjectURL(blob);
      console.log('debug-blobUrl', blobUrl);
      // @ts-ignore
      downloadBlob(blobUrl, name);
    })
    .catch((e) => console.error(e));
};

export const downloadMp3 = (url: string) => {
  axios({
    url, //your url
    method: 'GET',
    responseType: 'blob', // important
    headers: {
      Accept: '*/*',
      'Access-Control-Allow-Origin': '*',
      // Accept: 'audio/mpeg',
      'Content-type': 'audio/mpeg',
      // 'Access-Control-Allow-Methods': 'GET,POST,OPTIONS,DELETE,PUT',
      // 'Content-Disposition': 'attachment; filename="cool.mp3',
    },
  }).then((response) => {
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'file.pdf'); //or any other extension
    document.body.appendChild(link);
    link.click();
  });
};

export const downloadMp3d = (url: string) => {
  axios.get(url).then((response) => {
    // @ts-ignore
    const url = window.URL.createObjectURL(new Blob([response]));
    const link = document.createElement('a');
    link.href = url;
    const fileName = `${+new Date()}.mp3`; // whatever your file name .
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    link.remove(); // you need to remove that elelment which is created before.
  });
};

export const paramsToDeleteHelper = (
  params: { [name: string]: string },
  existParams: { [name: string]: string },
) => {
  // remove params with mutation
  const paramsToDelete = Object.entries(params);
  paramsToDelete.map((param) => {
    if (existParams[param[0]] && existParams[param[0]] === param[1]) {
      delete existParams[param[0]];
      delete params[param[0]];
    }

    return { ...param };
  });
};
